import { OrtService } from '../../services/suchseite/ort.service';

/**
 * Wandele technischen Umkreis-Wert in anzeigbares Label um.
 */
export function umkreisMitKm(umkreis: string): string {
  if (umkreis === OrtService.UMKREIS_VALUE_GANZER_ORT) {
    return 'ganzer Ort';
  } else {
    return umkreis + ' km';
  }
}
